import React from 'react';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import MarvelLink from '@marvelapp/marvel-ui/link';
import general from './style/general.module.css';

export default function NavLink({ url, title, isLight, linkType }) {
  const cx = classNames.bind({ ...general });

  const navLinksClasses = cx(general.navLinks, {
    [general.dark]: !isLight,
    [general.light]: isLight,
  });
  return (
    <Link className={navLinksClasses} to={url}>
      <MarvelLink type={linkType}>{title}</MarvelLink>
    </Link>
  );
}

NavLink.propTypes = {
  isLight: PropTypes.bool.isRequired,
  linkType: PropTypes.string,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/modules/Header/HeaderNav/NavLink/index.js